import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calenderIcon from "../../../assets/images/callender-icon.svg";

const RfpDate = ({ data: dataObj, handleDataChange }: any) => {
    const [startDate, setStartDate]: any = useState(dataObj?.content);

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setStartDate(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const handleDateChange = (date: any) => {
        setStartDate(date)
        handleDataChange({ key: 'date', value: new Date(date).toISOString() })
    }

    return (
        <>
            <div className="mb-6 w-72">
                <p className='text-[#344054] text-sm font-interMedium pb-1.5 pl-1'>{dataObj?.title}</p>
                <div className="relative">
                    <div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5] ">
                        <img
                            className="w-[22px] h-[22px] flex-shrink-0 "
                            src={calenderIcon}
                            alt="star icon"
                        />
                        <div className="custom-datepicker width-adjust w-full">

                            <DatePicker
                                className="custom-datepicker-input placeholder:text-[#667085] placeholder:text-base text-base text-[#344054] w-full caret-transparent"
                                selected={startDate}
                                onChange={(date) => handleDateChange(date)}
                            // onChange={(date) => setStartDate(date)}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RfpDate